import { Box, Typography } from "@mui/material";
import ReplaceMainUserButton from "./actions/ReplaceMainUserButton";
import { useClientDetails } from "../../context/clientDetailsContext";

const Header = () => {
  const { updateClientDetails, replaceMainUser } = useClientDetails();

  return (
    <>
      <Typography align="left" variant="h5">
        Owner
      </Typography>
      <Box sx={{ paddingRight: 2 }}>
        <ReplaceMainUserButton
          handleReplaceUser={() => {
            updateClientDetails.setAlert(null);
            replaceMainUser.setAlert(null);
            replaceMainUser.setReplacing(true);
          }}
        />
      </Box>
    </>
  );
};

export default Header;
